<ng-container *transloco="let t">
    <div
        class="flex overflow-y-auto grow h-[522px] flex-col-reverse max-w-full relative"
    >
        <!-- Messages List -->
        <div
            fuseScrollbar
            fuseScrollReset
            #fuseScrollbar="fuseScrollbar"
            [fuseScrollbarOptions]="{
                suppressScrollX: true,
                wheelPropagation: false
            }"
            class="flex flex-col flex-auto grow p-4 bg-card dark:bg-transparent max-w-full pb-20"
        >
            <ng-container
                *ngFor="
                    let message of messages;
                    let i = index;
                    let first = first;
                    let last = last;
                    trackBy: trackById
                "
            >
                <div
                    class="flex flex-col max-w-full"
                    [ngClass]="{
                        'items-end': message.isMine,
                        'items-start': !message.isMine,
                        'mt-2':
                            i > 0 && messages[i - 1].isMine === message.isMine,
                        'mt-3':
                            i > 0 && messages[i - 1].isMine !== message.isMine
                    }"
                >
                    <div
                        class="relative max-w-[85%] px-3 py-2 rounded-lg"
                        [ngClass]="{
                            'bg-primary text-white': message.isMine,
                            'bg-gray-100 text-gray-700': !message.isMine
                        }"
                        style="word-wrap: break-word; white-space: normal"
                    >
                        <div
                            class="min-w-4 leading-5 break-words marked-styling"
                            [innerHTML]="
                                message.isMine
                                    ? message.content
                                    : markDownContent(message.content)
                            "
                        ></div>
                    </div>

                    <div
                        class="my-0.5 text-sm font-medium text-secondary"
                        [ngClass]="{
                            'mr-1': message.isMine,
                            'ml-1': !message.isMine
                        }"
                    >
                        {{ message.createdAt | date : "HH:mm" }}
                    </div>
                </div>
            </ng-container>

            <div *ngIf="isLoading" class="flex justify-start mt-2">
                <div
                    class="bg-gray-300 text-black px-3 py-2 rounded-lg text-sm animate-pulse"
                >
                    {{ t("Typing...") }}
                </div>
            </div>
        </div>

        <!-- Composer: same pill shape as the agent-chat conversation composer
             (bordered surface shell, focus ring, round gradient send button). -->
        <div class="tutorial-composer absolute inset-x-0 bottom-0 p-3">
            <div class="tutorial-composer__shell flex items-end gap-2 py-1.5 ps-4 pe-1.5">
                <textarea
                    #messageInput
                    class="tutorial-composer__input flex-auto min-w-0 py-1.5"
                    rows="1"
                    cdkTextareaAutosize
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="4"
                    [(ngModel)]="message"
                    [placeholder]="t('Type a message')"
                    [attr.aria-label]="t('Message')"
                    (keydown)="onKeydown($event)"
                ></textarea>
                <app-voice-input [target]="messageInput"></app-voice-input>
                <button
                    type="button"
                    class="tutorial-composer__send sai-circle w-9 h-9"
                    [disabled]="!message.trim()"
                    [attr.aria-label]="t('Send')"
                    (click)="sendMessage()"
                >
                    <mat-icon class="icon-size-5" [svgIcon]="'heroicons_outline:arrow-up'"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</ng-container>
